<template>
  <Cart v-if="!footer && item.action == 'cart'" class="link" :cart="cart" :color="color" />
  <a
    v-else-if="!footer && !!item.status && applicationAction"
    class="nch--custom-menu nav-link link"
    :class="level > 0 ? 'item': ''"
    :href="applicationAction"
    role="button"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    :style="{color: color.secondary}"
  >
    <i class="mx-2" :class="item.icon" :style="{color: color.secondary}"></i>
    <span class="font-weight-bold">{{ item.translation.name }}</span>
  </a>
  <NavbarDashboard class="link" v-else-if="item.action === 'dashboard' && (user && !publicUser)" :title="item.translation.name" />
  <a
    v-else-if="item.action !== 'dashboard' && item.url"
    :class="level < 1 ? 'nch--custom-menu mx-3' : 'item suboption'"
    :style="{color: color.secondary}"
    :target="setTarget(item.target)"
    :href="item.url"
  >{{item.translation && item.translation.name ? item.translation.name : item.url}}</a>
</template>

<script>
import Cart from "./NavbarCart";
import NavbarDashboard from "./NavbarDashboard";


export default {
  name: "NavbarCustomOption",
  components: {
    Cart,
    NavbarDashboard
  },
  props: {
    item: Object,
    footer: Boolean,
    cart: Number,
    level: {
      type: Number,
      default: 0
    },
    user: {
      type: Object,
    },
    publicUser: {
      type: [Boolean, Number]
    }
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    }
  },
  computed: {
    color() {
      return this.$store.getters.NAV_COLOR;
    },
    applicationAction() {
      const actions = {
        plans: '/plans',
        blog: '/blog',
      };
      return actions[this.item.action];
    },
  }
};
</script>

<style scoped>
.nch--custom-menu {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  padding: 0 !important;
}
.suboption{
  color: #111 !important
}
</style>
